// extracted by mini-css-extract-plugin
export var dropdown = "PlayerModesPicker-module__dropdown___dOB9A";
export var dropdownWrapper = "PlayerModesPicker-module__dropdownWrapper___DQWMG";
export var option = "PlayerModesPicker-module__option___NFGRY";
export var optionTitle = "PlayerModesPicker-module__optionTitle___oZ+eU";
export var playersPerConsoleText = "PlayerModesPicker-module__playersPerConsoleText___0gzvI";